import { render, staticRenderFns } from "./ChecklistAcessorioCategoria.vue?vue&type=template&id=aea77a4e&"
import script from "./ChecklistAcessorioCategoria.vue?vue&type=script&lang=js&"
export * from "./ChecklistAcessorioCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports